import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {EnlargedView}        from "@Xpresso/routes/common/enlarged-view/enlarged-view";

import {ChangeTemplateModal} from "../../../product-options/change-tempalte-modal/change-template-modal";
import {ImageSelector}       from "./image-selector/image-selector";
import {ImageViewer}         from "../front-template-viewer/image-viewer/image-viewer";

export const BackTemplateSelector = ({allowReproof, isFromApproval, item, loadingProofs, selected, state, templateBacks, next}) => cs(
    consumeContext("apis"),
    consumeContext("routerHistory"),
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["changeTemplateModal", ({}, next) => ChangeTemplateModal({next})],
    ["view", (_, next) => UseState({
        initValue: {enlarged: false, key: 0, selected: selected.value},
        next,
    })],
    ["enlargedView", ({view}, next) => EnlargedView({
        images: templateBacks?.map((back) => ({url: back.image})),
        onChangeView: (key) => {
            view.onChange({...view.value, key: key, selected: templateBacks[key].id})
            selected.onChange(templateBacks[key].id)
        },
        viewing: view.value.key,
        next,
    })],
    ({apis, routerHistory, query, enlargedView, changeTemplateModal, view}) => next({
        render: () => (
            <div className="back-template-selector-bf1">
                {!loadingProofs.value ? ImageSelector({
                        allowReproof,
                        images: templateBacks?.map((back, i) => ({
                            id: back.id,
                            src: back.image,
                            selected: back.id === selected.value,
                            onSelect: () => new Promise<void>((resolve, reject) => {
                                let confirm = false
                                if(isFromApproval && item.sku.back !== back.id) {
                                    changeTemplateModal.show({
                                        confirm: async () => {
                                            routerHistory.replace(`/product-options/order/${item.itemId}`)
                                            selected.onChange(back.id)
                                            view.onChange({...view.value, key: i})
                                            await apis.next.approval.denyCcCart(query.id_cart)
                                            confirm = true
                                            return {confirm: true};
                                        },
                                        onClose: () => confirm ? resolve() : reject()
                                    })
                                } else {
                                    selected.onChange(back.id)
                                    view.onChange({...view.value, key: i})
                                }
                            }),
                            details: (
                                <div className="details-9ws">
                                    <div className="title">
                                        {back.name}
                                    </div>
                                </div>
                            ),
                        })),
                        loadingProofs,
                        state,
                        onEnlarge: () => enlargedView.show(),
                    })
                    : ImageViewer({
                        images: [{
                            src: templateBacks[view.value.key]?.image,
                            onClick: () => {},
                        }],
                        loading: !!loadingProofs.value,
                        onEnlarge: () => enlargedView.show(),
                        viewing: view.value.key,
                    })
                }
            </div>
        ),
    }),
);